// extracted by mini-css-extract-plugin
export default {"main":"styles_main__6SUUX","notAvailable":"styles_notAvailable__TEsNW","opacity":"styles_opacity__Z8Qjr"};